interface Props {
  onNext: () => void;
  onBack: () => void;
  canGoBack: boolean;
  canGoNext: boolean;
  isSubmitting?: boolean;
  isLastStep?: boolean;
}

export function NavigationButtons({
  onNext,
  onBack,
  canGoBack,
  canGoNext,
  isSubmitting = false,
  isLastStep = false,
}: Props) {
  return (
    <div className="flex flex-col gap-3 px-4 pb-8">
      <button
        type="button"
        onClick={onNext}
        disabled={!canGoNext || isSubmitting}
        className="hit-btn-primary"
        aria-label={isLastStep ? 'Enviar aplicación' : 'Continuar a la siguiente pregunta'}
      >
        {isSubmitting ? (
          <span className="flex items-center justify-center gap-2">
            <span className="w-4 h-4 border-2 border-hit-black/30 border-t-hit-black rounded-full animate-spin" />
            Enviando...
          </span>
        ) : isLastStep ? (
          'ENVIAR APLICACIÓN'
        ) : (
          'SEGUIR →'
        )}
      </button>

      {canGoBack && (
        <button
          type="button"
          onClick={onBack}
          disabled={isSubmitting}
          className="text-hit-gray-mid text-sm font-medium py-2 hover:text-hit-white transition-colors disabled:opacity-50"
          aria-label="Volver a la pregunta anterior"
        >
          ← ATRÁS
        </button>
      )}
    </div>
  );
}
